export default "__VITE_ASSET__ARI$6hjn__"